import { useCallback, useContext } from 'react';
import { FormGroup } from 'reactstrap';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { StarRating } from '../../../common/forms/Rating';
import {
    FormContext,
    FormLabel, SmallOutlineButton, Textarea, toasty,
} from '../../../common/forms/FormElements';
import { Modal } from '../../../common/Modal';
import { ApiRoutes } from '../../../Common';

export const RatingForm = ({ ...job }) => {
    const { values } = useContext(FormContext);
    const { jobDate, defaultTimesheetId } = values;

    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (values) => {
            const response = await httpClient.post(ApiRoutes.job.rate(), values);

            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['jobRequests', jobDate, defaultTimesheetId] });

            toasty.success('Thank you for leaving a rating!');
        },
    });

    const handleAddRatingButtonClick = useCallback(() => {
        Modal.show({
            onSubmit: mutation.mutateAsync,
            title: 'Add a Rating',
            initialValues: {
                rating: 0,
                timesheetId: job.timesheetId,
                jobId: job.jobId,
                assignmentDate: job.jobDate,
            },
            body: () => (
                <>
                    <StarRating
                        name="rating"
                        label="Rating"
                        required
                        error="You must provide a rating for this job"
                    />

                    <Textarea
                        name="comment"
                        placeholder="Any additional comments (optional)"
                    />
                </>
            ),
        });
    }, [mutation.mutateAsync, job]);

    if (job.rating) {
        return (
            <FormContext.Provider value={null}>
                <StarRating
                    label="Your rating"
                    value={job.rating}
                    name="rating"
                    labelClassName="text-small text-uppercase"
                    disabled
                />
            </FormContext.Provider>
        );
    }

    return (
        <FormGroup>
            <FormLabel
                label="Your rating"
                className="text-small text-uppercase"
            />

            <div>
                <SmallOutlineButton
                    onClick={handleAddRatingButtonClick}
                >
                    <FontAwesomeIcon
                        icon={faPlus}
                        className="mr-2"
                    />

                    Add Rating
                </SmallOutlineButton>
            </div>
        </FormGroup>
    );
};